<template>
  <resource-edit-wrapper
    :title="$t('resources.favorites_blocks.edit_favorites_block')"
    :need-modal="showModal"
    @saveAction="$refs['favoritesBlockForm'].submit()">
    <FavoritesBlockForm
      is-edit
      :favorites-block="item"
      @isDirtyForm="isDirtyForm"
      ref="favoritesBlockForm"></FavoritesBlockForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import FavoritesBlockForm from "@/components/forms/FavoritesBlockForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceEditWrapper,
      FavoritesBlockForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    created() {
      this.$admin.toast.info(this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.favorite_block"));
    },
  };
</script>
